import { all } from 'redux-saga/effects';

// eslint-disable-next-line import/no-cycle
import auth from './auth/saga';

export default function* rootSaga() {
  return yield all([auth]);
}
